export default "__VITE_ASSET__5b8822ad__"